import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '../../components/header/Header';
import Footer from '../../components/footer/Footer';
import sanpham from '../../api/sanpham';
import Logo from "../../images/caobangceritage.svg"
import styles from './SanPhamDetail.module.css';
import AiVoice from '../../components/AiVoice/AiVoice';
import { FaUser, FaPhoneAlt, FaMapMarkerAlt, FaHeart, FaShareAlt, FaFacebookF, FaRegCopy } from 'react-icons/fa';

const SanPhamDetailPage = () => {
  const { id } = useParams();
  const sp = sanpham.find(item => item.id === id);
  const [imgIdx, setImgIdx] = useState(0);
  const [lightbox, setLightbox] = useState(false);

  if (!sp) return (
    <>
      <Navbar Logo={Logo} />
      <div style={{padding:48, textAlign:'center', color:'#b71c1c', fontWeight:600}}>Không tìm thấy sản phẩm!</div>
      <Footer />
    </>
  );

  const nextImg = (e) => {
    e && e.stopPropagation();
    setImgIdx((imgIdx + 1) % sp.hinhAnh.length);
  };
  const prevImg = (e) => {
    e && e.stopPropagation();
    setImgIdx((imgIdx - 1 + sp.hinhAnh.length) % sp.hinhAnh.length);
  };

  return (
    <>
      <Navbar Logo={Logo} />
      <div className={styles.detailBg}>
        <div className={styles.detailCard} style={{animation: 'fadeInUp 0.7s both'}}>
          {/* Họa tiết SVG trang trí viền dưới card */}
          <img src="/vr/assets/img/pattern_deco.svg" alt="decor" style={{position:'absolute', bottom:0, left:0, width:120, opacity:0.13, pointerEvents:'none'}} />
          <div className={styles.leftCol}>
            {/* Carousel chỉ show 1 ảnh, căn giữa dọc, mũi tên chỉ hiện khi chưa mở lightbox */}
            <div style={{position:'relative', width:480, height:480, display:'flex', alignItems:'center', justifyContent:'center', marginBottom:8}}>
              <img
                src={sp.hinhAnh[imgIdx]}
                alt={sp.tenSanPham}
                className={styles.mainImg}
                style={{cursor:'zoom-in', maxHeight: '100%', maxWidth: '100%', objectFit: 'contain', display: 'block', margin: '0 auto'}}
                onClick={()=>setLightbox(true)}
                tabIndex={0}
                aria-label="Xem ảnh lớn"
              />
              {sp.hinhAnh.length > 1 && !lightbox && (
                <>
                  <button className={`${styles.lightboxArrow} ${styles.arrowInCard} ${styles.left}`} onClick={prevImg} aria-label="Ảnh trước">
                    &#8592;
                  </button>
                  <button className={`${styles.lightboxArrow} ${styles.arrowInCard} ${styles.right}`} onClick={nextImg} aria-label="Ảnh tiếp theo">
                    &#8594;
                  </button>
                </>
              )}
            </div>
          </div>
          <div className={styles.rightCol}>
            <h2 className={styles.tenSanPham}>{sp.tenSanPham}
              <button onClick={()=>{
                let favs = JSON.parse(localStorage.getItem('favs')||'[]');
                if (!favs.includes(sp.id)) favs.push(sp.id); else favs = favs.filter(x=>x!==sp.id);
                localStorage.setItem('favs',JSON.stringify(favs));
                window.dispatchEvent(new Event('storage'));
              }} className={styles.heartBtn} aria-label="Yêu thích">
                <FaHeart color="#e53935" style={{filter:'drop-shadow(0 1px 2px #fff)'}}/>
              </button>
            </h2>
            <div className={styles.gia}>{typeof sp.gia === 'number' ? sp.gia.toLocaleString('vi-VN') + '₫' : sp.gia}</div>
            <div className={styles.moTa}>{sp.moTa}</div>
            <div className={styles.infoRow}><b>Mã sản phẩm:</b> {sp.id}</div>
            <div className={styles.infoRow}><b>Loại sản phẩm:</b> {sp.loaiSanPham}</div>
            <div className={styles.infoRow}><b>Xuất xứ:</b> {sp.xuatXu}</div>
            <div className={styles.infoRow}><b>Tình trạng:</b> {sp.tinhTrang}</div>
            <div className={styles.infoRow}><b>Ngày đăng:</b> 2024-06-01</div>
            <div className={styles.sellerBox} style={{animation:'slideInRight 0.7s 0.2s both'}}>
              <div className={styles.sellerTitle}>Thông tin người bán</div>
              <div><FaUser style={{marginRight:6}}/><b>Họ tên:</b> {sp.nguoiBan.ten}</div>
              <div><FaPhoneAlt style={{marginRight:6}}/><b>SĐT:</b> <a href={`tel:${sp.nguoiBan.sdt}`} className={styles.sdtLink}>{sp.nguoiBan.sdt}</a></div>
              <div><FaMapMarkerAlt style={{marginRight:6}}/><b>Địa chỉ:</b> {sp.nguoiBan.diaChi}</div>
            </div>
            <div style={{marginTop:16, display:'flex', gap:16, alignItems:'center'}}>
              <Link to="/sanpham" className={styles.backLink}>← Quay lại danh sách sản phẩm</Link>
              <button className={styles.shareBtn} title="Chia sẻ Facebook" onClick={()=>window.open(`https://www.facebook.com/sharer/sharer.php?u=${window.location.href}`,'_blank')}><FaFacebookF/></button>
              <button className={styles.shareBtn} title="Copy link" onClick={()=>{navigator.clipboard.writeText(window.location.href)}}><FaRegCopy/></button>
            </div>
          </div>
        </div>
        {/* Card câu chuyện sản phẩm */}
        <div style={{maxWidth:1300, margin:'32px auto', background:'#fffbe7', borderRadius:16, boxShadow:'0 2px 12px #0001', padding:32, fontSize:18, color:'#5d4037', lineHeight:1.7}}>
          <div style={{fontWeight:700, fontSize:22, marginBottom:12, color:'#b71c1c', letterSpacing:0.5}}>Câu chuyện sản phẩm</div>
          <div>{sp.cauChuyen || 'Chưa có thông tin giới thiệu cho sản phẩm này.'}</div>
        </div>
        {/* Lightbox full màn hình */}
        {lightbox && (
          <div className={styles.lightboxOverlay} onClick={()=>setLightbox(false)}>
            <button className={styles.lightboxClose} onClick={()=>setLightbox(false)} aria-label="Đóng">×</button>
            <img src={sp.hinhAnh[imgIdx]} alt={sp.tenSanPham} className={styles.lightboxImg} />
            {sp.hinhAnh.length > 1 && (
              <>
                <button className={`${styles.lightboxArrow} ${styles.left}`} onClick={prevImg} aria-label="Ảnh trước">&#8592;</button>
                <button className={`${styles.lightboxArrow} ${styles.right}`} onClick={nextImg} aria-label="Ảnh tiếp theo">&#8594;</button>
              </>
            )}
          </div>
        )}
      </div>
      <AiVoice />
      <Footer />
    </>
  );
};

export default SanPhamDetailPage; 